import {appRouter} from '@netx/core-next/instance/router';
import {decodeBase64Rules} from './decodeBase64Rules';
import {encodeBase64Rules} from './encodeBase64Rules';
import type {SearchCriteria} from '../types';

export const updateUrlSearchString = (
	updatedSort: Partial<Pick<SearchCriteria, 'sortField' | 'sortOrder'>>,
) => {
	const {hash} = window.location;
	const isAdvanced = hash.match(/search\/advanced\//) != null;
	const isAttributeHistory =
		!isAdvanced && hash.match(/search\/attribute\/history\//) != null;
	if ((!isAdvanced && !isAttributeHistory) || !Object.keys(updatedSort).length)
		return;

	const str = hash
		.replace(/#(search\/advanced\/|search\/attribute\/history\/)/, '')
		.replace(/\/page\/\d+/, '');
	const rules = decodeBase64Rules(str);
	if (!rules) return;

	const newStr = encodeBase64Rules({
		...rules,
		...updatedSort,
	});

	appRouter.navigate(
		`${isAdvanced ? 'search/advanced' : 'search/attribute/history'}/${newStr}`,
		true,
	);
};

export default updateUrlSearchString;
